<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © BarrelRace.app
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Designed & Developed by Archiviz Studios LLC
                </div>
            </div>
        </div>
    </div>
</footer>